import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const PageWrapper = styled.section`
  width: 100%;
  max-width: ${layout.maxWidth};
  margin: 0 auto;
  padding: ${space[5]} ${space[5]} ${space[9]};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${space[9]};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space[10]} ${space[8]} ${space[10]};
    gap: ${space[10]};
  }
`;

export const HeaderBlock = styled.header`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space[6]};
  text-align: center;
`;

export const TotalHeading = styled.h1`
  margin: 0;
  font-family: ${fonts.heading};
  font-weight: ${fonts.weight.normal};
  font-size: ${fonts.size['2xl']};
  line-height: 1.2;
  color: ${colors.fontPrimary};

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${fonts.size['3xl']};
  }
`;

export const TotalHeadingPrefix = styled.span`
  margin-right: ${space[2]};
`;

export const HeaderActions = styled.div<{ $narrow?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${space[3]};
  width: 100%;
  max-width: ${({ $narrow }) => ($narrow ? '320px' : '560px')};
  margin: ${({ $narrow }) => ($narrow ? `-${space[7]} auto 0` : '0 auto')};

  @media (min-width: ${layout.desktopBreakpoint}) {
    flex-direction: row;
    justify-content: center;
  }
`;

export const HeaderActionsButton = styled.div`
  flex: 1;
`;

export const BasketSection = styled.div<{ $empty?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${layout.narrowMaxWidth};
  margin-left: auto;
  margin-right: auto;
  margin-top: ${({ $empty }) => ($empty ? `-${space[8]}` : '0')};
`;

export const DiscountRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[3]};
  margin-top: ${space[5]};

  @media (min-width: ${layout.desktopBreakpoint}) {
    flex-direction: row;
    align-items: flex-start;
    gap: ${space[3]};
    margin-top: ${space[6]};
  }
`;

export const DiscountColumn = styled.div`
  flex: 1;
  min-width: 0;
`;
